import { CertificationsValues } from 'api/types/ReferenceDataTS';
import { Link } from './global';
import { CompanyLabel } from './BrandPortal/Companies';
import {
  CustomAttributesTypes,
  CustomAttributeValue
} from 'components/common/Portals/CustomAttributes/types';
import { ExhibitionTypes, PortalTypes } from 'portals/types';

export interface Event {
  from: string | Date; //'YYYY-MM-DD'
  to: string | Date; //'YYYY-MM-DD'
  name: string;
  description?: string;
  venue: Venue;
  key: string;
  type: PortalTypes | ExhibitionTypes;
  img?: string;
  status?: string;
  links: Link[];
  images: any;
  event?: {
    key: string;
    name: string;
  };
  //Brand Portal Event Attributes
  custom_attributes?: {
    definition: {
      key: string;
      name: string;
      required: boolean;
      type: CustomAttributesTypes;
    };
    value: CustomAttributeValue;
  }[];
  company_private_attributes?: { label: CompanyLabel };
  product_private_attributes?: {
    //this object needs to be completed
    data: { [type in UxBeautyPrivateAttributes]: string[] } & {
      tagline: string;
      certificationLink: string;
      certifications: EventCertification[];
    };
  };
}
export enum UxBeautyPrivateAttributes {
  AWARDS = 'awards',
  MARKET_TRENDS = 'marketTrends',
  TECHNOLOGY = 'technology',
  PRESERVATIVE = 'preservative',
  COUNTRY_ORIGIN = 'countryOrigin',
  CLINICAL_TIME_DELIVERY = 'clinicalTimeDelivery',
  LIFE_CYCLE_ANALYSIS = 'lifeCycleAnalysis',
  STORAGE_CONDITIONS = 'storageConditions',
  PUBLICATIONS = 'publications',
  PH_STABILITY_RANGE = 'phStabilityRange',
  TEMPERATURE_STABILITY = 'temperatureStability',
  FORMULATION_TIPS = 'formulationTips',
  BIOLOGICAL_TARGET = 'biologicalTarget',
  MATERIAL_CODE = 'materialCode',
  PRODUCTION_SITE = 'productionSite',
  CONSUMER_TESTS = 'consumerTests',
  POSITIONING = 'positioning',
  SAMPLE_UNIT_PRICE = 'sampleUnitPrice',
  SAMPLE_UNIT_SIZE = 'sampleUnitSize',
  VICOSITY = 'vicosity',
  TAGLINE = 'tagline',
  VISCOSITY = 'viscosity',
  CATEGORY_MANAGER = 'categoryManager',
  STRATEGIC_PORTFOLIO = 'strategicPortfolio',
  STANDARD_LEAD_TIME = 'standardLeadTime',
  EXTRA_RND_TESTS = 'extraRnDTests',
  BUSINESS_PRIORITY = 'businessPriority',
  VIDEO = 'video',
  IN_STOCK = 'inStock'
}

interface EventCertification {
  value: CertificationsValues;
  properties: {
    type: string;
  };
}

export interface Venue {
  address: {
    street: string;
    street_additional?: string;
    postal_code: string;
    city: string;
    country: string;
  };
  name?: string;
  description?: string;
  coordinates?: {
    lat?: string;
    longit?: string;
    link?: string;
  };
}
